// eslint-disable-next-line
import React, { useCallback } from 'react';
import { Autocomplete, AutocompleteProps } from '@material-ui/lab';
import {
  INPUT_LOADING_TEXT,
  INPUT_NO_OPTIONS_TEXT,
} from 'components/constants';
import { CustomTextField } from 'components/forms';
import { AxiosCustomError } from 'core/errors';
import { TextFieldProps } from 'formik-material-ui';

type Props = {
  isLoading: boolean;
  data: any[] | undefined;
  error: unknown;
  childrenFields: { fieldName: string }[];
} & TextFieldProps &
  Partial<AutocompleteProps>;

const AutocompleteDomicile: React.FC<Props> = ({
  isLoading,
  field,
  data,
  label,
  error,
  form,
  childrenFields,
  ...restProps
}) => {
  const { onChange, ...restFieldProps } = field;
  const { onChange: onChangeRestsProps } = restProps;

  const { setFieldValue, isSubmitting } = form;

  const handleChange = useCallback(
    (e: React.ChangeEvent<{}>, value) => {
      if (value?.name !== field?.value?.name) {
        childrenFields.forEach((each) => setFieldValue(each.fieldName, null));
      }
      setFieldValue(field.name, value);
      return onChangeRestsProps?.(e, value);
    },
    [field.name, field.value, setFieldValue, childrenFields, onChangeRestsProps]
  );

  const errorDescription = (error as AxiosCustomError)?.customError
    ?.description;

  return (
    <Autocomplete
      loadingText={INPUT_LOADING_TEXT}
      noOptionsText={INPUT_NO_OPTIONS_TEXT}
      size="medium"
      {...restProps}
      loading={isLoading}
      disabled={isLoading || isSubmitting || restProps.disabled}
      value={field.value}
      onChange={handleChange}
      options={data}
      getOptionLabel={(option) => option.name}
      renderInput={(renderProps) => {
        return (
          <CustomTextField
            {...(renderProps as any)}
            label={label}
            form={form}
            field={restFieldProps}
            helperText={errorDescription}
            isLoading={isLoading}
            fullWidth
          />
        );
      }}
    />
  );
};

export default AutocompleteDomicile;
